module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai217-359912603bc30ea63556c9a18aba84ba.jpg";